import React from 'react';
import { NavLink } from 'react-router-dom';

import classes from "./NavigationItem.css";

const NavigationItem = props => (
    <li className={classes.NavigationItem}>
        <NavLink to={props.link} exact activeClassName={classes.active} >
            {props.children}
        </NavLink>
            
    </li>
); 

export default NavigationItem;


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.jsx